<template>
    <div
        class="text-end"
        :class="{ 'font-monospace': monospace }"
    >
        {{ internalTimestamp }}
    </div>
</template>

<script setup lang="ts">
import { TimeSpan } from '@/objects/TimeSpan';
import { parseTimespanIntoStringFromFormat, type TimeType } from '@/utilities/dateutils';
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        value: TimeSpan | null;

        /**
         * The format to use for the time
         * @default TIMEMS3
         */
        format?: TimeType;

        /**
         * If the text should be monospace
         * @default true
         */
        monospace?: boolean;

        /**
         * If set, then the value will be shown as a timestamp 00:00:00.000
         */
        nullValueAsTimestamp?: boolean;
    }>(),
    {
        format: 'TIMEMS3',
        nullValueAsTimestamp: false,
        monospace: true,
    },
);

// The internalTimestamp should be the value as milliseconds added to the current date
const internalTimestamp = computed<string>(() =>
    props.value == null && props.nullValueAsTimestamp
        ? parseTimespanIntoStringFromFormat(TimeSpan.Empty(), props.format)
        : parseTimespanIntoStringFromFormat(props.value, props.format),
);
</script>
